export const GAME_NAME_LIST = [
  {
    label: '王者荣耀',
    value: 'yxzj',
  },
  {
    label: '天龙八部',
    value: 'tlbb',
  },
  {
    label: '最强NBA',
    value: 'zqnba',
  },
  {
    label: '使命召唤手游',
    value: 'codm',
  },
  {
    label: 'QQ飞车手游',
    value: 'speedm',
  },
  {
    label: '英雄联盟',
    value: 'lgamem',
  },
  {
    label: '欢乐斗地主',
    value: 'hlddz',
  },
  {
    label: '穿越火线',
    value: 'cfm',
  },
  {
    label: '合金弹头',
    value: 'hjdt',
  },
  {
    label: '高能英雄',
    value: 'gngame',
  },
  {
    label: '元梦之星',
    value: 'ymzx',
  },
  {
    label: '和平精英',
    value: 'cjm',
  },
  {
    label: '冒险岛：枫之传说',
    value: 'mxdm',
  },
  {
    label: '妄想山海',
    value: 'shanhai',
  },
  {
    label: '塔瑞斯世界',
    value: 'trssj',
  },
  {
    label: '宝可梦大集结',
    value: 'nishiki',
  },
  {
    label: '欢乐麻将',
    value: 'majiang',
  },
  {
    label: '极品飞车',
    value: 'nfsm',
  },
  {
    label: '海岛奇兵',
    value: 'bbb',
  },
  {
    label: '无畏契约：源能行动',
    value: 'codev',
  },
  {
    label: 'QQ飞车端游',
    value: 'speed',
  },
  {
    label: '美职篮全明星',
    value: 'nba2km',
  },
  {
    label: '皇室战争',
    value: 'cr',
  },
  {
    label: 'QQ炫舞',
    value: 'x5m',
  }
];

export const SMS_MODAL_THEME_LIST = [
  {
    label: '深色',
    value: 'dark',
  },
  {
    label: '浅色',
    value: 'light',
  },
];
